import { render, staticRenderFns } from "./technician-detail.vue?vue&type=template&id=09819f3c&lang=pug"
import script from "./technician-detail.vue?vue&type=script&lang=js"
export * from "./technician-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports